(function () {
    'use strict';

    angular.module('GorillaBoy')
    .factory('TranslateFactory', [
        function () {
            var translateFactory = {
                shortenText: function (text, max_length) {
                    var textLength = text.length,
                        MAX_TEXT_LENGTH = max_length ? max_length : 35;
                    if (textLength > MAX_TEXT_LENGTH) {
                        text = text.substring(0, MAX_TEXT_LENGTH) + '…';
                    }
                    return text;
                }
            };
            return translateFactory;
        }
    ]);
}());
